
import { Options, Vue } from "vue-class-component";
import { useStore } from "../store";
import { MutationTypes } from "../store/mutation-types";

@Options({
  props: {
    text: Array,
  },
  data() {
    return {
      firstIndex: 0,
      currentDaySection: 0,
      // @ts-ignore
      dayDisplay: this.text.slice(0, 4),
    };
  },
  computed: {
    leftArrow: function () {
      return this.firstIndex > 0;
    },
    rightArrow: function () {
      return this.text.length > this.firstIndex + 4 ? true : false;
    },
  },
  methods: {
    activeButton(value: number, text: string) {
      const data = { number: value, filter: text, menu: 2 };
      return this.$store.commit(MutationTypes.SET_DAY_MENU, data);
    },
    // determines the css
    chooseDisplay(index: number) {
      return this.$store.state.activeDayMenu.number === index
        ? "btn-active"
        : "btn";
    },
    // switch days when needed
    handleClick(arrow: string) {
      if (arrow === "right") {
        return this.firstIndex + 5 <= this.text.length
          ? ((this.firstIndex = this.firstIndex + 4),
            (this.rightArrow = true),
            (this.dayDisplay = this.text.slice(
              this.firstIndex,
              this.firstIndex + 4
            )))
          : (this.rightArrow = false);
      }
      if (arrow === "left") {
        return (
          (this.firstIndex = this.firstIndex - 4),
          (this.dayDisplay = this.text.slice(
            this.firstIndex,
            this.firstIndex + 4
          ))
        );
      }
    },
  },
})
export default class DayMenuButtons extends Vue {
  store = useStore();
  text!: string[];
}
